import {ReportMobileControlled} from 'template'
import {useSearchParams, useNavigate} from 'react-router-dom'
import {aliasFields, filterFields} from './fields'
import {toCurrency} from 'utils/functions'
import {VmView} from 'components'

export default function PrdLapPenjualanObatResep() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const uid = searchParams.get('dctid')
  const resepDokterMandiri = searchParams.get('resep-mandiri')

  let dataFields = ['pasnama', 'nama_apotek', 'status_ambil']

  const resepDokterMandiriProps = resepDokterMandiri
    ? {
        defaultFilter: {
          activeFilter: {
            pjappid: 1,
          },
          activeFilterHeadLabel: {
            'Semua Jenis Resep': 'Resep Dokter Mandiri',
          },
          activeFilterHead: ['Semua Jenis Resep'],
        },
      }
    : {
        defaultFilter: {
          activeFilter: {
            pjappid: 2,
          },
          activeFilterHeadLabel: {
            'Semua Jenis Resep': 'Resep Dokter Online',
          },
          activeFilterHead: ['Semua Jenis Resep'],
        },
      }

  return (
    <ReportMobileControlled
      headerFields={[{name: 'pjtanggal', dateFormat: true}, 'pjnofaktur']}
      dataFields={dataFields}
      additionalApiParams={{
        uid,
        reg: 'dbdok',
        pjappid: resepDokterMandiri ? 1 : 2,
      }}
      statusDbColumn="pjdelivery"
      aliasFields={aliasFields}
      apiUrl={
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-lap-penjualan-resep/index'
      }
      filterFields={filterFields}
      headerTitle="Laporan Resep Dokter"
      searchPlaceholder="Cari Faktur / Resep / Pasien "
      detailAttr={{
        button: true,
        buttonLabel: 'Detail',
        buttonAction: item =>
          navigate(`/prd-lap-penjualan-obat-resep/${item.pjid}/${uid}`),
      }}
      footerLabel="No Resep: "
      footerValue={{name: 'pjresep'}}
      footerDividerVisible={false}
      exportApiUrl={`${process.env.REACT_APP_BASE_URL_DOKTER}/prd-lap-penjualan-resep/export`}
      exportApiParams={{uid}}
      countLabel="Total Insentif"
      customCountValue={{getter: val => toCurrency(val, 2)}}
      renderStatus={(item, labelStatus, statusTextStyle) => {
        return (
          <VmView className="flex flex-col items-end justify-center">
            <VmView className={statusTextStyle}>{labelStatus}</VmView>
            {item.pjappid !== 'dk13' ? (
              <img
                src="/vmedis-logo-alt.png"
                alt="vmedis-logo"
                className="w-10 mt-2 mx-auto"
              />
            ) : (
              <></>
            )}
          </VmView>
        )
      }}
      {...resepDokterMandiriProps}
    />
  )
}
